import { render } from "./ContentCarousel.vue?vue&type=template&id=8dfc1f28"
import script from "./ContentCarousel.vue?vue&type=script&lang=js"
export * from "./ContentCarousel.vue?vue&type=script&lang=js"

import "./ContentCarousel.vue?vue&type=style&index=0&id=8dfc1f28&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__